export default __webpack_public_path__ + "static/media/wolf-lane-logo-inverse.ff911108.png";